<template>
  <div>
    <div class="row" style="overflow-wrap: break-word;">
      <!-- <h1>Streaks</h1> -->
      <div class="col-lg-3 px-4 py-4" style="background-color: var(--bootstrapgrey); border-right: 15px solid white; margin-bottom: 15px;">
        <!-- {{ days }} -->
        <!-- {{ totalFilled }}
        {{ totalHealth }}
        {{ totalStrength }}
        {{ totalStretch }}
        {{ totalFood }} -->
        <h3 class="dashboard-header medium-shrink" style="margin-bottom: 0.1rem;">Health</h3>
        <h3 class="dashboard-header medium-shrink" style="">Insurance</h3>
        <hr>
        <h1>{{ totalHealth/totalFilled * 100 | singleDecimalSeconds }}%</h1>
        <hr>
        <h1>{{ insuranceStreak }} <span style="font-size: 15px;">day streak</span></h1>
      </div>
      <div class="col-lg-3 px-4 py-4" style="background-color: var(--bootstrapgrey); border-right: 15px solid white; margin-bottom: 15px;">
        <h3 class="dashboard-header medium-shrink" style="margin-bottom: 0.1rem;">Healthy</h3>
        <h3 class="dashboard-header medium-shrink" style="">Eating</h3>
        <hr>
        <h1>{{ totalFood/totalFilled * 100 | singleDecimalSeconds }}%</h1>
        <hr>
        <h1>{{ eatingStreak }} <span style="font-size: 15px;">day streak</span></h1>
      </div>
      <div class="col-lg-3 px-4 py-4" style="background-color: var(--bootstrapgrey); border-right: 15px solid white; margin-bottom: 15px;">
        <h3 class="dashboard-header medium-shrink" style="margin-bottom: 0.1rem;">Strength</h3>
        <h3 class="dashboard-header medium-shrink" style="">Workout</h3>
        <hr>
        <h1>{{ totalStrength/totalFilled * 100 | singleDecimalSeconds }}%</h1>
        <hr>
        <h1>{{ strengthStreak }} <span style="font-size: 15px;">day streak</span></h1>
      </div>
      <div class="col-lg-3 px-4 py-4" style="background-color: var(--bootstrapgrey); border-right: 15px solid white; margin-bottom: 15px;">
        <h3 class="dashboard-header medium-shrink" style="margin-bottom: 0.1rem;">Stretching</h3>
        <h3 class="dashboard-header medium-shrink" style="">Routine</h3>
        <hr>
        <h1>{{ totalStretch/totalFilled * 100 | singleDecimalSeconds }}%</h1>
        <hr>
        <h1>{{ stretchStreak }} <span style="font-size: 15px;">day streak</span></h1>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-lg-3 px-4 py-4" style="background-color: var(--bootstrapgrey); border-right: 15px solid white; margin-bottom: 15px;">
        <h3 class="dashboard-header" style="">Strength Workout</h3>
        <hr>
      </div>
      <div class="col-lg-3 px-4 py-4" style="background-color: var(--bootstrapgrey); border-right: 15px solid white; margin-bottom: 15px;">
        <h3 class="dashboard-header" style="">Stretching Routine</h3>
        <hr>
      </div> -->
    </div>
  </div>

</template>

<script>
  import axios from 'axios'

  export default {
    props: ['user'],
    data () {
      return {
        userID: null,
        days: null,
        totalFilled: 0,
        totalHealth: 0,
        totalStrength: 0,
        totalStretch: 0,
        totalFood: 0,
        insuranceStreak: 0,
        eatingStreak: 0,
        strengthStreak: 0,
        stretchStreak: 0,
      }
    },
    created() {
      // this.userID = this.$store.getters.userID
      this.userID = this.user.id
      this.calculateStreaks()
    },
    methods: {
      calculateStreaks() {
        // this.userID = this.$store.getters.userID
        let insuranceStreak = true
        let eatingStreak = true
        let strengthStreak = true
        let stretchStreak = true

        axios.get('/api/days/?user='.concat(this.userID))
          .then(res => {
            console.log(res)
            this.days = res.data
            // https://www.geeksforgeeks.org/javascript-array-prototype-reverse/
            // Want the days from newest to oldest for calculating streaks
            this.days = this.days.reverse()
            for (var day in this.days) {
              console.log(this.days[day].filled)
              if (this.days[day].filled) {
                this.totalFilled += 1
                if (this.days[day].health_insurance) {
                  this.totalHealth += 1
                  if (insuranceStreak) {
                    this.insuranceStreak += 1
                  }
                } else {
                  insuranceStreak = false
                }
                if (this.days[day].strength) {
                  this.totalStrength += 1
                  if (strengthStreak) {
                    this.strengthStreak += 1
                  }
                } else {
                  strengthStreak = false
                }
                if (this.days[day].stretching) {
                  this.totalStretch += 1
                  if (stretchStreak) {
                    this.stretchStreak += 1
                  }
                } else {
                  stretchStreak = false
                }
                if (this.days[day].eating) {
                  this.totalFood += 1
                  if (eatingStreak) {
                    this.eatingStreak += 1
                  }
                } else {
                  eatingStreak = false
                }
              }
            }
          })
          .catch(error => console.log(error))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/Streaks2.vue